import Vue from 'vue';
import Router from 'vue-router';
import Cabin from '@/views/Cabin.vue';
import Reserva from '@/views/Reserva.vue';
import Home from './views/Home.vue';
import store from '@/store';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Home,
    },
    {
      path: '/reservas',
      name: 'Reservas',
      component: () => import(/* webpackChunkName: "menu" */ './views/Reservas.vue'),
      beforeEnter(to, from, next) {
        setTimeout(() => {
          if (window.localStorage.getItem('api_token') && window.localStorage.getItem('role')) {
            next();
          } else {
            next('/');
          }
        }, 1000);
      },
    },
    {
      path: '/agenda',
      name: 'Agenda',
      component: () => import(/* webpackChunkName: "menu" */ './views/Agenda.vue'),
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem('api_token') && window.localStorage.getItem('role')) {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      path: '/cabana/:id',
      name: 'Cabaña',
      props: true,
      component: Cabin,
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem('api_token') && window.localStorage.getItem('role')) {
          next();
        } else {
          next('/');
        }
      },
      // component: () => import(/* webpackChunkName: "menu" */ './views/Cabin.vue'),
    },
    {
      path: '/reserva/:reserva',
      name: 'Reserva',
      props: true,
      component: Reserva,
      beforeEnter(to, from, next) {
        if (window.localStorage.getItem('api_token') && window.localStorage.getItem('role')) {
          next();
        } else {
          next('/');
        }
      },
    },
  ],
});


